module.exports = "\n<div class=\"deviceMobileApp text-center clearfix\">\n <div class=\"deviceMobileApp text-center\">\n\t<h3>Thing or Mobile App?</h3>\n\t<img src=\"/assets/images/device_mobile_app.png\">\n\t<div class=\"col-md-12\">\n\t\t<button class=\"btn btn-primary\" (click)=\"navigateToOnboard('device')\" id=\"btn-thing\">Thing it is</button>\n\t\t<button class=\"btn btn-primary\" (click)=\"navigateToOnboard('app')\" id=\"btn-app\">Mobile App</button>\n\t</div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/intro-wizard/start/start.component.html
// module id = 1425
// module chunks = 7